export default __webpack_public_path__ + "static/media/happy-face.6d2fe6a6.svg";